import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-feedback-loop-modal',
  templateUrl: './feedback-loop-modal.component.html',
  styleUrls: ['./feedback-loop-modal.component.scss']
})
export class FeedbackLoopModalComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
  }

  close(result: any) {
    this.dialogRef.close(result);
  }

}
